import { useParams } from "react-router-dom";
import { EditState } from "../Types";

export function useEditRouteParams() {
  const { id, tab, state } = useParams<{
    id: string;
    state: EditState;
    tab: string;
  }>();

  return {
    id,
    tab,
    state,
  };
}
